import { createAction, props } from '@ngrx/store'
import { FieldType } from '../../models'

export const setFieldTypes = createAction(
    '[Set Field Types(App)] SET_FIELD_TYPES',
    props<{ fieldTypes: FieldType[] }>(),
)
